import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './ShortComment.module.scss';

import ClippedImage from 'common/components/ClippedImage/ClippedImage';

export default class ShortComment extends Component {
  static propTypes = {
    comment: PropTypes.object.isRequired,
    size: PropTypes.object.isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const {
      className,
      size: { width, height },
      comment: {
        text,
        author: { fullName, position, photo }
      }
    } = this.props;

    return (
      <div className={`${styles.CommentContainer} ${className}`}>
        <q className={styles.Citation}>{text}</q>
        <div className={styles.SignatureContainer}>
          <ClippedImage
            id="1"
            width={width}
            height={height}
            borderWidth={'1'}
            url={photo}
          />
          <div className={styles.Signature}>
            <h2 className={styles.Name}>{fullName}</h2>
            <h3 className={styles.Title}>{position}</h3>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ShortComment/ShortComment.js